import React, { useState } from "react";
import {validateEmail} from "../../../functions/EmailValidation";
import Alert from "../../../controls/Alert";

const checkEmailAddresses = (emailArray) => {
  for (let i=0; i<emailArray.length; i++) {
    if (!validateEmail(emailArray[i].trim()))
      return emailArray[i];
  }
  return "";
}

const SendCateringOrderValidator = (props) => {
  const record = props.record;
  const [state, setState] = useState({
    error: null,
    errorMessage: null,
    field: null,
  });

  let field = null;
  let error = false;
  let errorMessage = "";
  let id = null;


  if (!error && !record.orderEmail ) {
    error = true;
    errorMessage = "'To' address is required";
    id = "orderEmail";
  }
  let invalidEmail = record.orderEmail ? checkEmailAddresses(record.orderEmail.split(",")) : "";
  if (!error && invalidEmail !== "") {
    error = true;
    errorMessage = `'${invalidEmail}' is not a valid TO email address`;
    id = "orderEmail";
  }
  if (!error && record.carbonCopy && record.carbonCopy !== "") {
    invalidEmail = checkEmailAddresses(record.carbonCopy.split(","));
    if (invalidEmail !== ""){
      error = true;
      errorMessage = `'${invalidEmail}' is not a valid CC email address`;
      id = "carbonCopy";
    }
  }
  if (!error && !record.orderSubject ) {
    error = true;
    errorMessage = "'Subject' is required";
    id = "orderSubject";
  }

  if (error !== state.error || errorMessage !== state.errorMessage) {
    setState({ ...state, error, errorMessage, field });
    if (props.onChange) {
      props.onChange({ error, errorMessage, field });
    }
  }

  return (
    <Alert open={error} severity="error" message={errorMessage} id={id}/>
  );

}

export default SendCateringOrderValidator;
